export function mod(a: number, b: number) {
  return ((a % b) + b) % b;
}
